import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    style: {
      width: _vm.width
    }
  }, [_c('div', {
    ref: "sureUser",
    staticClass: "user-container",
    style: {
      maxHeight: _vm.height
    },
    on: {
      "&scroll": function scroll($event) {
        return _vm.getScrollsss($event);
      },
      "click": _vm.handleShow
    }
  }, [_vm.showSelectData.length == 0 ? _c('div', {
    staticClass: "placeholder"
  }, [_c('a-icon', {
    attrs: {
      "type": "plus"
    }
  }), _vm._v("点击选择 ")], 1) : _vm._e(), _vm._l(_vm.showSelectData, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "user-box"
    }, [item.type === 1 ? _c('div', {
      staticClass: "user-box-row"
    }, [_c('a-icon', {
      attrs: {
        "type": "user"
      }
    }), _c('div', {
      staticClass: "wto"
    }, [_vm._v(_vm._s(item.name))]), _c('a-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.disValue,
        expression: "!disValue"
      }],
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "close-circle"
      },
      on: {
        "click": function click($event) {
          return _vm.allDelUser(item);
        }
      }
    })], 1) : item.type === 2 ? _c('div', {
      staticClass: "user-box-row"
    }, [_c('a-icon', {
      attrs: {
        "type": "tag"
      }
    }), _c('div', {
      staticClass: "wto"
    }, [_vm._v(_vm._s(item.name))]), _c('a-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.disValue,
        expression: "!disValue"
      }],
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "close-circle"
      },
      on: {
        "click": function click($event) {
          return _vm.allDelJob(item);
        }
      }
    })], 1) : _c('div', {
      staticClass: "user-box-row"
    }, [_c('a-icon', {
      attrs: {
        "type": "home"
      }
    }), _c('div', {
      staticClass: "wto"
    }, [_vm._v(_vm._s(item.name))]), _c('a-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.disValue,
        expression: "!disValue"
      }],
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "close-circle"
      },
      on: {
        "click": function click($event) {
          return _vm.allDelDept(item);
        }
      }
    })], 1)]);
  })], 2), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 18
    }
  }, [_vm.deptFlag || _vm.jobFlag || _vm.userFlag ? _c('span', [_vm._v("已选择")]) : _vm._e(), _vm.deptFlag ? _c('span', [_c('strong', [_vm._v(_vm._s(_vm.deptNum))]), _vm._v(" 组织 ")]) : _vm._e(), _vm.jobFlag ? _c('span', [_c('strong', [_vm._v(_vm._s(_vm.jobNum))]), _vm._v(" 岗位 ")]) : _vm._e(), _vm.userFlag ? _c('span', [_c('strong', [_vm._v(_vm._s(_vm.userNum))]), _vm._v(" 成员 ")]) : _vm._e()]), !_vm.disabled ? _c('a-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm.allSelectData.length > 0 ? _c('a-popconfirm', {
    attrs: {
      "title": "确认清空已选数据吗?",
      "ok-text": "确认",
      "cancel-text": "取消"
    },
    on: {
      "confirm": _vm.clearAll
    }
  }, [_c('a', [_c('a-icon', {
    attrs: {
      "type": "delete"
    }
  }), _vm._v("清空")], 1)]) : _vm._e()], 1)]) : _vm._e()], 1), _c('a-modal', {
    attrs: {
      "title": "选择人员",
      "width": "65%",
      "maskClosable": false,
      "closable": true
    },
    model: {
      value: _vm.showModal,
      callback: function callback($$v) {
        _vm.showModal = $$v;
      },
      expression: "showModal"
    }
  }, [_c('template', {
    slot: "footer"
  }, [_c('div', {
    staticClass: "box-footer"
  }, [_vm.allSelectData.length > 0 ? _c('a-popconfirm', {
    attrs: {
      "title": "取消将清空已选择数据?",
      "ok-text": "确认",
      "cancel-text": "取消"
    },
    on: {
      "confirm": _vm.handleCancel
    }
  }, [_c('a-button', [_vm._v("取消")])], 1) : _vm._e(), _c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSumbit
    }
  }, [_vm._v("确定")])], 1)]), _c('div', {
    staticClass: "modal-box"
  }, [_c('div', {
    staticClass: "modal-left"
  }, [_c('div', {
    staticClass: "modal-search"
  }, [_vm._v(" 所属组织及岗位： "), _c('a-cascader', {
    style: {
      width: '80%'
    },
    attrs: {
      "options": _vm.options,
      "show-search": {
        filterOption: _vm.filterOption
      },
      "placeholder": "请选择所属组织及岗位",
      "getPopupContainer": function getPopupContainer(triggerNode) {
        return triggerNode.parentNode;
      },
      "disabled": true
    },
    on: {
      "change": _vm.onOrganAndJob
    },
    model: {
      value: _vm.cascaderVal,
      callback: function callback($$v) {
        _vm.cascaderVal = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "cascaderVal"
    }
  }), _c('a-popover', {
    attrs: {
      "title": "提示",
      "placement": "right"
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_c('p', [_vm._v("请先选择自己的所属组织及岗位，")]), _c('p', [_vm._v("选择后将自动进行相关查询。")])];
      },
      proxy: true
    }])
  }, [_c('a-icon', {
    style: {
      color: '#1890ff',
      marginLeft: '5px'
    },
    attrs: {
      "type": "question-circle",
      "theme": "filled"
    }
  })], 1)], 1), _c('div', {
    on: {
      "click": _vm.testOther
    }
  }, [_c('a-tabs', {
    attrs: {
      "tabBarGutter": 5
    },
    on: {
      "change": _vm.changeTab
    },
    model: {
      value: _vm.pickObj.itemize,
      callback: function callback($$v) {
        _vm.$set(_vm.pickObj, "itemize", $$v);
      },
      expression: "pickObj.itemize"
    }
  }, _vm._l(_vm.tabList, function (item, index) {
    return _c('a-tab-pane', {
      key: item.itemize,
      attrs: {
        "tab": item.name
      }
    }, [10000 == item.itemize ? _c('div', {
      staticClass: "modal-tab"
    }, [_vm.treeData.length === 0 ? _c('div', {
      staticClass: "data-empty"
    }, [_c('a-empty', {
      attrs: {
        "image": _vm.simpleImage
      }
    })], 1) : _c('a-tree', {
      attrs: {
        "checkable": "",
        "checkStrictly": "",
        "replace-fields": {
          key: 'id'
        },
        "defaultExpandedKeys": _vm.defaultKey,
        "auto-expand-parent": _vm.autoExpandParent,
        "tree-data": _vm.treeData
      },
      on: {
        "check": _vm.onCheck,
        "select": _vm.onSelectAll
      },
      model: {
        value: _vm.testTree,
        callback: function callback($$v) {
          _vm.testTree = $$v;
        },
        expression: "testTree"
      }
    })], 1) : _vm._e(), 10001 == item.itemize ? _c('div', {
      staticClass: "modal-tab"
    }, [_vm.showTree ? _c('div', {
      staticClass: "modal-tab-loading"
    }, [_c('a-spin')], 1) : _c('div', {
      staticClass: "modal-tab-left"
    }, [_vm.treeData.length === 0 ? _c('div', {
      staticClass: "data-empty"
    }, [_c('a-empty', {
      attrs: {
        "image": _vm.simpleImage
      }
    })], 1) : _c('a-tree', {
      attrs: {
        "replace-fields": {
          key: 'id'
        },
        "defaultExpandedKeys": _vm.defaultKey,
        "disabled": _vm.showUser,
        "tree-data": _vm.treeData
      },
      on: {
        "select": _vm.handleTree
      }
    })], 1), _vm.showUser ? _c('div', {
      staticClass: "modal-tab-loadings"
    }, [_c('a-spin')], 1) : _c('div', {
      staticClass: "modal-tab-right"
    }, [_c('div', {
      class: _vm.allUserData.length > 12 ? 'modal-all' : 'modal-alls'
    }, [_c('div', [_vm._v("全选(" + _vm._s(_vm.allUserData.length) + ")")]), _c('a-checkbox', {
      attrs: {
        "checked": _vm.isAllChecked,
        "disabled": _vm.allUserData.length > 0 ? false : true
      },
      on: {
        "change": _vm.handleAll
      }
    })], 1), _c('div', {
      ref: "userbox",
      refInFor: true,
      staticClass: "list-left",
      on: {
        "&scroll": function scroll($event) {
          return _vm.getScroll($event);
        }
      }
    }, [_c('a-list', {
      attrs: {
        "size": "small",
        "data-source": _vm.allUserData
      },
      scopedSlots: _vm._u([{
        key: "renderItem",
        fn: function fn(item) {
          return _c('a-list-item', {}, [_c('div', {
            staticClass: "modal-select-user"
          }, [_c('div', [_c('a-icon', {
            attrs: {
              "type": "user"
            }
          }), _vm._v(" " + _vm._s(item.name) + " ")], 1), _c('a-checkbox', {
            attrs: {
              "checked": item.disabled === 2 ? true : false
            },
            on: {
              "click": function click($event) {
                return _vm.selectUser(item);
              }
            }
          })], 1)]);
        }
      }], null, true)
    })], 1)])]) : _vm._e(), 10002 == item.itemize ? _c('div', {
      staticClass: "modal-tab"
    }, [_vm.showTree ? _c('div', {
      staticClass: "modal-tab-loading"
    }, [_c('a-spin')], 1) : _c('div', {
      staticClass: "modal-tab-left"
    }, [_vm.treeData.length === 0 ? _c('div', {
      staticClass: "data-empty"
    }, [_c('a-empty', {
      attrs: {
        "image": _vm.simpleImage
      }
    })], 1) : _c('a-tree', {
      attrs: {
        "replace-fields": {
          key: 'id'
        },
        "defaultExpandedKeys": _vm.defaultKey,
        "disabled": _vm.showUser,
        "tree-data": _vm.treeData
      },
      on: {
        "select": _vm.handleTree
      }
    })], 1), _vm.showUser ? _c('div', {
      staticClass: "modal-tab-loadings"
    }, [_c('a-spin')], 1) : _c('div', {
      staticClass: "modal-tab-right"
    }, [_c('div', {
      class: _vm.allUserData.length > 12 ? 'modal-all' : 'modal-alls'
    }, [_c('div', [_vm._v("全选(" + _vm._s(_vm.allUserData.length) + ")")]), _c('a-checkbox', {
      attrs: {
        "checked": _vm.isAllChecked,
        "disabled": _vm.allUserData.length > 0 ? false : true
      },
      on: {
        "change": _vm.handleAll
      }
    })], 1), _c('div', {
      ref: "userbox",
      refInFor: true,
      staticClass: "list-left",
      on: {
        "&scroll": function scroll($event) {
          return _vm.getScroll($event);
        }
      }
    }, [_c('a-list', {
      attrs: {
        "size": "small",
        "data-source": _vm.allUserData
      },
      scopedSlots: _vm._u([{
        key: "renderItem",
        fn: function fn(item) {
          return _c('a-list-item', {}, [_c('div', {
            staticClass: "modal-select-user"
          }, [_c('div', {
            staticClass: "title",
            attrs: {
              "title": "".concat(item.name, "\u3010").concat(item.organName, "\u3011")
            }
          }, [_c('a-icon', {
            attrs: {
              "type": "user"
            }
          }), _vm._v(" " + _vm._s(item.name)), item.organName ? _c('span', [_vm._v("【" + _vm._s(item.organName) + "】")]) : _vm._e()], 1), _c('a-checkbox', {
            attrs: {
              "checked": item.disabled === 2 ? true : false
            },
            on: {
              "click": function click($event) {
                return _vm.selectUser(item);
              }
            }
          })], 1)]);
        }
      }], null, true)
    })], 1)])]) : _vm._e(), 10003 == item.itemize ? _c('div', {
      staticClass: "modal-tab"
    }, [_vm.showTree ? _c('div', {
      staticClass: "modal-tab-left-loading"
    }, [_c('a-spin')], 1) : _c('div', {
      staticClass: "modal-tab-job-left"
    }, [_vm.treeData.length === 0 ? _c('div', {
      staticClass: "data-empty"
    }, [_c('a-empty', {
      attrs: {
        "image": _vm.simpleImage
      }
    })], 1) : _c('div', [_c('a-input-search', {
      staticStyle: {
        "padding": "6px",
        "border-bottom": "1px solid #dbdbdb"
      },
      attrs: {
        "placeholder": "请输入组织名称",
        "enter-button": ""
      },
      on: {
        "search": _vm.organizationNameOnSearch
      }
    }), _c('a-tree', {
      attrs: {
        "show-icon": "",
        "replace-fields": {
          key: 'id'
        },
        "defaultExpandedKeys": _vm.defaultKey,
        "expanded-keys": _vm.organizationExpandedKeys,
        "auto-expand-parent": _vm.organizationAutoExpandParent,
        "disabled": _vm.showUser,
        "tree-data": _vm.treeData
      },
      on: {
        "expand": _vm.organizationOnExpand,
        "select": _vm.handleTree
      },
      scopedSlots: _vm._u([{
        key: "switcherIcon",
        fn: function fn(_ref) {
          var switcherCls = _ref.switcherCls;
          return [_c('a-icon', {
            staticStyle: {
              "font-size": "16px"
            },
            attrs: {
              "type": "right-square"
            }
          })];
        }
      }, {
        key: "title",
        fn: function fn(_ref2) {
          var title = _ref2.title;
          return [title.indexOf(_vm.searchValue) > -1 ? _c('span', [_vm._v(" " + _vm._s(title.substr(0, title.indexOf(_vm.searchValue))) + " "), _c('span', {
            staticStyle: {
              "color": "#c7a368"
            }
          }, [_vm._v(_vm._s(_vm.searchValue))]), _vm._v(" " + _vm._s(title.substr(title.indexOf(_vm.searchValue) + _vm.searchValue.length)) + " ")]) : _c('span', [_vm._v(_vm._s(title))])];
        }
      }], null, true)
    })], 1)]), _c('div', {
      staticClass: "modal-tab-job-middle"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('div', [_vm._v("岗位")]), _c('a-input-search', {
      staticStyle: {
        "width": "200px",
        "padding-left": "12px"
      },
      attrs: {
        "placeholder": "请输入岗位名称",
        "enter-button": ""
      },
      on: {
        "search": _vm.organizationJobNameOnSearch
      }
    }), _c('a-checkbox', {
      staticStyle: {
        "padding": "4px"
      },
      attrs: {
        "checked": _vm.isAllJobChecked,
        "disabled": _vm.allJobUserData.length > 0 ? false : true
      },
      on: {
        "change": _vm.JobHandleAll
      }
    })], 1), _vm.showJobUserLoading ? _c('div', {
      staticClass: "modal-tab-loadings"
    }, [_c('a-spin')], 1) : _c('a-list', {
      staticClass: "list-job-left",
      attrs: {
        "size": "small",
        "data-source": _vm.allJobUserData,
        "split": false
      },
      scopedSlots: _vm._u([{
        key: "renderItem",
        fn: function fn(item) {
          return _c('a-list-item', {
            class: item.id == _vm.pickUserObj.postId && item.organId == _vm.pickUserObj.organId ? 'selectd' : '',
            on: {
              "click": function click($event) {
                return _vm.jobClick(item);
              }
            }
          }, [_c('div', {
            staticClass: "modal-select-user title-job",
            attrs: {
              "title": "".concat(item.name, "\u3010").concat(item.organName, "\u3011")
            }
          }, [_vm._v(" " + _vm._s(item.name)), item.organName ? _c('span', [_vm._v("【" + _vm._s(item.organName) + "】")]) : _vm._e()]), _c('a-checkbox', {
            staticStyle: {
              "margin-right": "14px"
            },
            attrs: {
              "checked": item.disabled === 2 ? true : false
            },
            on: {
              "click": function click($event) {
                $event.stopPropagation();
                return _vm.selectJob(item);
              }
            }
          })], 1);
        }
      }], null, true)
    })], 1), _c('div', {
      staticClass: "modal-tab-job-right"
    }, [_c('div', {
      class: _vm.allUserData.length > 12 ? 'modal-all' : 'modal-alls'
    }, [_c('div', [_vm._v("全选(" + _vm._s(_vm.allUserData.length) + ")")]), _c('a-input-search', {
      staticStyle: {
        "width": "200px",
        "padding-left": "12px"
      },
      attrs: {
        "placeholder": "请输入姓名",
        "enter-button": ""
      },
      on: {
        "search": _vm.organizationManNameOnSearch
      }
    }), _c('a-checkbox', {
      attrs: {
        "checked": _vm.isAllChecked,
        "disabled": _vm.allUserData.length > 0 ? false : true
      },
      on: {
        "change": _vm.handleAll
      }
    })], 1), _vm.showJobUser ? _c('div', {
      staticClass: "modal-tab-loadings"
    }, [_c('a-spin')], 1) : _c('a-list', {
      staticClass: "list-left",
      attrs: {
        "size": "small",
        "data-source": _vm.allUserData
      },
      on: {
        "&scroll": function scroll($event) {
          return _vm.getScrollss($event);
        }
      },
      scopedSlots: _vm._u([{
        key: "renderItem",
        fn: function fn(item) {
          return _c('a-list-item', {}, [_c('div', {
            staticClass: "modal-select-user"
          }, [_c('div', [_c('a-icon', {
            attrs: {
              "type": "user"
            }
          }), _vm._v(" " + _vm._s(item.name) + " ")], 1), _c('a-checkbox', {
            attrs: {
              "checked": item.disabled === 2 ? true : false
            },
            on: {
              "click": function click($event) {
                return _vm.selectUser(item);
              }
            }
          })], 1)]);
        }
      }], null, true)
    })], 1)]) : _vm._e(), 10004 == item.itemize ? _c('div', {
      staticClass: "modal-tab"
    }, [_vm.showTree ? _c('div', {
      staticClass: "modal-tab-loading"
    }, [_c('a-spin')], 1) : _c('div', {
      staticClass: "modal-tab-left"
    }, [_vm.treeData.length === 0 ? _c('div', {
      staticClass: "data-empty"
    }, [_c('a-empty', {
      attrs: {
        "image": _vm.simpleImage
      }
    })], 1) : _c('a-tree', {
      attrs: {
        "replace-fields": {
          key: 'id'
        },
        "defaultExpandedKeys": _vm.defaultKey,
        "disabled": _vm.showUser,
        "tree-data": _vm.treeData
      },
      on: {
        "select": _vm.handleTree
      }
    })], 1), _vm.showUser ? _c('div', {
      staticClass: "modal-tab-loadings"
    }, [_c('a-spin')], 1) : _c('div', {
      staticClass: "modal-tab-right"
    }, [_c('div', {
      class: _vm.allUserData.length > 12 ? 'modal-all' : 'modal-alls'
    }, [_c('div', [_vm._v("全选(" + _vm._s(_vm.allUserData.length) + ")")]), _c('a-checkbox', {
      attrs: {
        "checked": _vm.isAllChecked,
        "disabled": _vm.allUserData.length > 0 ? false : true
      },
      on: {
        "change": _vm.handleAll
      }
    })], 1), _c('div', {
      ref: "userbox",
      refInFor: true,
      staticClass: "list-left",
      on: {
        "&scroll": function scroll($event) {
          return _vm.getScroll($event);
        }
      }
    }, [_c('a-list', {
      attrs: {
        "size": "small",
        "data-source": _vm.allUserData
      },
      scopedSlots: _vm._u([{
        key: "renderItem",
        fn: function fn(item) {
          return _c('a-list-item', {}, [_c('div', {
            staticClass: "modal-select-user"
          }, [_c('div', [_c('a-icon', {
            attrs: {
              "type": "user"
            }
          }), _vm._v(" " + _vm._s(item.name) + " ")], 1), _c('a-checkbox', {
            attrs: {
              "checked": item.disabled === 2 ? true : false
            },
            on: {
              "click": function click($event) {
                return _vm.selectUser(item);
              }
            }
          })], 1)]);
        }
      }], null, true)
    })], 1)])]) : _vm._e(), 10005 == item.itemize ? _c('div', {
      staticClass: "modal-tab"
    }, [_vm.showTree ? _c('div', {
      staticClass: "modal-tab-loading"
    }, [_c('a-spin')], 1) : _c('div', {
      staticClass: "modal-tab-job-left"
    }, [_vm.treeData.length === 0 ? _c('div', {
      staticClass: "data-empty"
    }, [_c('a-empty', {
      attrs: {
        "image": _vm.simpleImage
      }
    })], 1) : _c('a-tree', {
      attrs: {
        "replace-fields": {
          key: 'id'
        },
        "defaultExpandedKeys": _vm.defaultKey,
        "disabled": _vm.showUser,
        "tree-data": _vm.treeData
      },
      on: {
        "select": _vm.handleTree
      }
    })], 1), _vm.showUser ? _c('div', {
      staticClass: "modal-tab-loadings"
    }, [_c('a-spin')], 1) : _c('div', {
      staticClass: "modal-tab-job-middle"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('div', [_vm._v("岗位")])]), _c('a-list', {
      staticClass: "list-job-left",
      attrs: {
        "size": "small",
        "data-source": _vm.allJobUserData,
        "split": false
      },
      scopedSlots: _vm._u([{
        key: "renderItem",
        fn: function fn(item) {
          return _c('a-list-item', {
            class: item.id == _vm.pickUserObj.postId ? 'selectd' : '',
            on: {
              "click": function click($event) {
                return _vm.jobUserClick(item);
              }
            }
          }, [_c('div', {
            staticClass: "modal-select-user"
          }, [_vm._v(" " + _vm._s(item.name) + " ")])]);
        }
      }], null, true)
    })], 1), _vm.showJobUser ? _c('div', {
      staticClass: "modal-tab-loadings"
    }, [_c('a-spin')], 1) : _c('div', {
      staticClass: "modal-tab-job-right"
    }, [_c('div', {
      class: _vm.allUserData.length > 12 ? 'modal-all' : 'modal-alls'
    }, [_c('div', [_vm._v("全选(" + _vm._s(_vm.allUserData.length) + ")")]), _c('a-checkbox', {
      attrs: {
        "checked": _vm.isAllChecked,
        "disabled": _vm.allUserData.length > 0 ? false : true
      },
      on: {
        "change": _vm.handleAll
      }
    })], 1), _c('div', {
      ref: "userbox",
      refInFor: true,
      staticClass: "list-left",
      on: {
        "&scroll": function scroll($event) {
          return _vm.getScroll($event);
        }
      }
    }, [_c('a-list', {
      attrs: {
        "size": "small",
        "data-source": _vm.allUserData
      },
      scopedSlots: _vm._u([{
        key: "renderItem",
        fn: function fn(item) {
          return _c('a-list-item', {}, [_c('div', {
            staticClass: "modal-select-user"
          }, [_c('div', [_c('a-icon', {
            attrs: {
              "type": "user"
            }
          }), _vm._v(" " + _vm._s(item.name) + " ")], 1), _c('a-checkbox', {
            attrs: {
              "checked": item.disabled === 2 ? true : false
            },
            on: {
              "click": function click($event) {
                return _vm.selectUser(item);
              }
            }
          })], 1)]);
        }
      }], null, true)
    })], 1)])]) : _vm._e()]);
  }), 1)], 1)]), _c('div', {
    staticClass: "modal-right",
    on: {
      "click": _vm.testOther
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "10px",
      "font-size": "12px"
    }
  }, [_vm._v("提示：点击"), _c('a-icon', {
    staticStyle: {
      "color": "#1890FF"
    },
    attrs: {
      "type": "retweet"
    }
  }), _vm._v("图标可切换。当前:" + _vm._s(_vm.modeSwitch ? '直接人员搜索' : '默认'))], 1), _vm.modeSwitch ? _c('div', {
    staticClass: "modal-right-search"
  }, [_c('a-icon', {
    staticStyle: {
      "font-size": "22px",
      "color": "#1890FF",
      "cursor": "pointer"
    },
    attrs: {
      "type": "retweet"
    },
    on: {
      "click": _vm.onModeSwitch
    }
  }), _c('a-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "show-search": "",
      "allowClear": "",
      "mode": "multiple",
      "placeholder": "请输入姓名或手机号搜索",
      "option-filter-prop": "children",
      "maxTagCount": 1
    },
    on: {
      "search": _vm.fetchUser,
      "change": _vm.handleChange
    },
    model: {
      value: _vm.allValue,
      callback: function callback($$v) {
        _vm.allValue = $$v;
      },
      expression: "allValue"
    }
  }, [_vm.fetching ? _c('a-spin', {
    attrs: {
      "slot": "notFoundContent",
      "size": "small"
    },
    slot: "notFoundContent"
  }) : _vm._e(), _vm._l(_vm.allUserList, function (item) {
    return _c('a-select-option', {
      key: item.id,
      attrs: {
        "data": item
      }
    }, [_vm._v(" " + _vm._s(item.name) + "-" + _vm._s(item.mobile) + " ")]);
  })], 2)], 1) : _c('div', {
    staticClass: "modal-right-search"
  }, [_c('a-icon', {
    staticStyle: {
      "font-size": "22px",
      "color": "#1890FF",
      "cursor": "pointer"
    },
    attrs: {
      "type": "retweet"
    },
    on: {
      "click": _vm.onModeSwitch
    }
  }), _c('a-input-search', {
    attrs: {
      "placeholder": "搜索组织名称或岗位名称",
      "enter-button": ""
    },
    on: {
      "search": _vm.searchUser
    },
    model: {
      value: _vm.testValue,
      callback: function callback($$v) {
        _vm.testValue = $$v;
      },
      expression: "testValue"
    }
  })], 1), _c('div', {
    staticClass: "modal-right-top"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.textName) + "：" + _vm._s(_vm.showSearch ? _vm.searchAllData.length : _vm.allSelectData.length) + " ")]), _vm.allSelectData.length > 0 && _vm.textName === '已选' ? _c('a-popconfirm', {
    attrs: {
      "title": "确认清空已选数据吗?",
      "ok-text": "确认",
      "cancel-text": "取消"
    },
    on: {
      "confirm": _vm.handleClear
    }
  }, [_c('a', [_vm._v("清空")])]) : _vm._e()], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.showSearch,
      expression: "!showSearch"
    }],
    ref: "selectUserBox",
    staticClass: "list-right",
    on: {
      "&scroll": function scroll($event) {
        return _vm.getScrolls($event);
      }
    }
  }, [_c('a-list', {
    attrs: {
      "size": "small",
      "data-source": _vm.selectData
    },
    scopedSlots: _vm._u([{
      key: "renderItem",
      fn: function fn(item) {
        return _c('a-list-item', {}, [item.type === 1 ? _c('div', {
          staticClass: "modal-user"
        }, [_c('div', [_c('a-icon', {
          attrs: {
            "type": "user"
          }
        }), _vm._v(" " + _vm._s(item.name) + " ")], 1), _c('a-icon', {
          attrs: {
            "type": "close-circle"
          },
          on: {
            "click": function click($event) {
              return _vm.delUser(item);
            }
          }
        })], 1) : item.type === 2 ? _c('div', {
          staticClass: "modal-user"
        }, [_c('div', [_c('a-icon', {
          attrs: {
            "type": "tag"
          }
        }), _vm._v(" " + _vm._s(item.name)), item.organName ? _c('span', [_vm._v("【" + _vm._s(item.organName) + "】")]) : _vm._e()], 1), _c('a-icon', {
          attrs: {
            "type": "close-circle"
          },
          on: {
            "click": function click($event) {
              return _vm.delJob(item);
            }
          }
        })], 1) : _c('div', {
          staticClass: "modal-user"
        }, [_c('div', [_c('a-icon', {
          attrs: {
            "type": "home"
          }
        }), _vm._v(" " + _vm._s(item.name) + " ")], 1), _c('a-icon', {
          attrs: {
            "type": "close-circle"
          },
          on: {
            "click": function click($event) {
              return _vm.delDept(item);
            }
          }
        })], 1)]);
      }
    }])
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showSearch,
      expression: "showSearch"
    }],
    ref: "searchBox",
    staticClass: "list-right",
    on: {
      "&scroll": function scroll($event) {
        return _vm.searchs($event);
      }
    }
  }, [_c('a-list', {
    attrs: {
      "size": "small",
      "data-source": _vm.searchData
    },
    scopedSlots: _vm._u([{
      key: "renderItem",
      fn: function fn(item) {
        return _c('a-list-item', {}, [item.type === 1 ? _c('div', {
          staticClass: "modal-user"
        }, [_c('div', [_c('a-icon', {
          attrs: {
            "type": "user"
          }
        }), _vm._v(" " + _vm._s(item.name) + " ")], 1), _c('a-icon', {
          attrs: {
            "type": "close-circle"
          },
          on: {
            "click": function click($event) {
              return _vm.delUser(item);
            }
          }
        })], 1) : item.type === 2 ? _c('div', {
          staticClass: "modal-user"
        }, [_c('div', [_c('a-icon', {
          attrs: {
            "type": "tag"
          }
        }), _vm._v(" " + _vm._s(item.name)), item.organName ? _c('span', [_vm._v("【" + _vm._s(item.organName) + "】")]) : _vm._e()], 1), _c('a-icon', {
          attrs: {
            "type": "close-circle"
          },
          on: {
            "click": function click($event) {
              return _vm.delJob(item);
            }
          }
        })], 1) : _c('div', {
          staticClass: "modal-user"
        }, [_c('div', [_c('a-icon', {
          attrs: {
            "type": "home"
          }
        }), _vm._v(" " + _vm._s(item.name) + " ")], 1), _c('a-icon', {
          attrs: {
            "type": "close-circle"
          },
          on: {
            "click": function click($event) {
              return _vm.delDept(item);
            }
          }
        })], 1)]);
      }
    }])
  })], 1)])])], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };